import { render } from "./IconPenalty1.vue?vue&type=template&id=22d0c9ea&ts=true"
import script from "./IconPenalty1.vue?vue&type=script&lang=ts"
export * from "./IconPenalty1.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__